import { Col, Container, Row } from "react-bootstrap"
import FormatDate from "../../formatters/FormatDate"
import FormatGender from "../../formatters/FormatGender"
import { DonorInformationModel } from "./OrderModels"
import FormatPhone from "../../formatters/FormatPhone"

export interface GovOrderDonorInfo extends DonorInformationModel {
  accessCode?: number
}

const GovOrderDonorInfo = (props: GovOrderDonorInfo) => {
  const {
    donorId,
    firstName,
    lastName,
    accessCode,
    birthdate,
    gender,
    daytimePhone
  } = props

  return (
    <Container fluid className="px-0 mb-3">
      <Row>
        <Col md={2}>
          <span className="h6">ID:</span> {donorId}
        </Col>
        <Col md={2}>
          <span className="h6">First Name:</span> {firstName}
        </Col>
        <Col md={2}>
          <span className="h6">Last Name:</span> {lastName}
        </Col>
        <Col md={2}>
          <span className="h6">Access Code:</span> {accessCode}
        </Col>
        <Col></Col>
      </Row>
      <Row>
        <Col md={2}>
          <span className="h6">DOB:</span> {FormatDate(birthdate)}
        </Col>
        <Col md={2}>
          <span className="h6">Gender:</span> {FormatGender(gender)}
        </Col>
        <Col></Col>
      </Row>
      <Row>
        <Col md={12}>
          <span className="h6">Phone:</span> {FormatPhone(daytimePhone || "")}
        </Col>
      </Row>
    </Container>
  )
}

export default GovOrderDonorInfo
